<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow bg-secondary">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
                    แก้ไขข้อมูลพนักงาน
                  </h3>
                </div>
                <div class="col text-right">
                  <base-button type="primary" size="sm" @click="saveEmployee"
                    >บันทึก</base-button
                  >
                  <base-button type="danger" size="sm" @click="deleteEmployee"
                    >ลบ</base-button
                  >
                </div>
              </div>
            </div>

            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col-md-2">
                  <base-input
                    alternative=""
                    label="รหัสพนักงาน"
                    placeholder="รหัสพนักงาน"
                    input-classes="form-control-alternative"
                    v-model="model.code"
                  />
                </div>
                <div class="col-md-10">
                  <base-input
                    alternative=""
                    label="ชื่อพนักงาน"
                    placeholder="ชื่อพนักงาน"
                    input-classes="form-control-alternative"
                    v-model="model.name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <base-input
                    alternative=""
                    label="Username"
                    placeholder="Username"
                    input-classes="form-control-alternative"
                    v-model="model.email"
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    alternative=""
                    label="Password"
                    placeholder="Password"
                    type="password"
                    input-classes="form-control-alternative"
                    v-model="password"
                    ref="password"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../router";
import axios from "axios";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "employeeDetail",
  mixins: [kickMixin],
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      password: "",
      model: {
        id: 1,
        code: "",
        name: "",
        email: "",
      },
    };
  },
  methods: {
    loadEmployee: function() {
      var localApp = this;
      axios
        .get("/api/employee/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.model = response.data.data;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    saveEmployee: function() {
      if (this.$refs.password.value.trim() != "") {
        this.model.password = this.password;
      }
      var localApp = this;
      axios
        .patch(
          "/api/employee/" + this.$route.params.id,
          localApp.model,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            router.push("/employee");
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    deleteEmployee: function() {
      axios
        .delete(
          "/api/employee/" + this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 204) {
            router.push("/employee");
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadEmployee();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto;
}
label,
.form-control,
.btn {
  font-size: 1rem !important;
}

h3 {
  font-size: 1.2rem;
}
</style>
